const L = require('leaflet');
require('leaflet.markercluster');
require('leaflet-extra-markers');
const $ = require('jquery');
const lozad = require('lozad');

$(function () {
    const mapObserver = lozad('#shop-list-map', {
        rootMargin: '250px 0px',
        loaded: function (el) {

            var mymap = L.map('shop-list-map').setView([45.506208, 6.676340], 14);

            var OpenStreetMap_France = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                maxZoom: 19,
                attribution: '&copy; Openstreetmap France | &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            });

            OpenStreetMap_France.addTo(mymap);
            mymap.scrollWheelZoom.disable();

            var customMarker = L.icon({
                iconUrl: '/images/marker-maps.png',
                // shadowUrl: '/images/marker-maps-shadow.png',
                iconSize: [37, 37], // size of the icon
                // shadowSize: [99, 61], // size of the shadow
                // iconAnchor: [22, 62], // point of the icon which will correspond to marker's location
                // shadowAnchor: [5, 60],  // the same for the shadow
                // popupAnchor: [10, -55]
            });

            var markers = [];
            var markerGroup = L.markerClusterGroup({
                spiderfyDistanceMultiplier: 1,
                iconCreateFunction: function (cluster) {
                    let markers = cluster.getAllChildMarkers();
                    return L.ExtraMarkers.icon({
                        icon: 'fa-number',
                        number: markers.length,
                        markerColor: 'black',
                        shape: 'square',
                        prefix: 'fa'
                    });
                }
            });

            $.each(window.MAP_MARKERS, function (key, data) {

                var txtPopup = "<div style='text-align:center;'>";

                txtPopup += "<p><strong>" + data.title + " - " + data.localization + "</strong><br />";

                if (data.streetNumber != '')
                    txtPopup += " " + data.streetNumber + " ";

                if (data.streetName != '')
                    txtPopup += " " + data.streetName + "<br />";

                if (data.streetAdditionnal != '')
                    txtPopup += " " + data.streetAdditionnal + "<br />";

                if (data.postcode != '')
                    txtPopup += " " + data.postcode + " " + data.city;

                if (data.phone != '')
                    txtPopup += "<br /><br /><strong>Tél.</strong> " + data.phone;
                if (data.mail != '')
                    txtPopup += "<br /><strong>Email.</strong> " + data.mail;

                txtPopup += "</p>";

                if (data.shopUrl != '')
                    txtPopup += "<p><a href=\"" + data.shopUrl + "\" class=\"btn\">Entrer</a></p>";

                if (data.uriSkimium != '')
                    txtPopup += "<p><a href=\"" + data.uriSkimium + "\" class=\"external-link btn\">Louer des skis à " + data.localization + "</a></p>";

                txtPopup += "</p>";

                txtPopup += "</div>";

                var marker = L.marker([data.lat, data.long], {icon: customMarker}).bindPopup(txtPopup);

                markers.push(marker);
                markerGroup.addLayer(marker);
            });

            var group = new L.featureGroup(markers);
            mymap.fitBounds(group.getBounds());
            mymap.addLayer(markerGroup);
        }
    });
    mapObserver.observe();

    /*
     -- @ SERVICES IN SHOP DETAIL PAGE @ --
        * Used in:
            - Shop detail page
    */
    $(document).on('click', '.js-change-tab', function (e) {
        e.preventDefault();

        var _link = $(this),
            _rel = $(this).data('rel'),
            _parent = $(this).data('parent');

        if ($(_rel).find(".body").html() == "") {
            $.get(_link.attr('href'), function (data) {
                $(_rel).find(".body").html(data);
                $(_parent + ' .js-change-tab').add(_parent + ' .right .item-detail').removeClass('active');
                $(_rel).add(_link).addClass('active');
            })
        } else {
            if (!_link.hasClass('active')) {
                $(_parent + ' .js-change-tab').add(_parent + ' .right .item-detail').removeClass('active');
                $(_rel).add(_link).addClass('active');
            }
        }


    });
});
